import { Color } from '@kite-js/theme-types';

const orange: Color = {
    // Remove this block when do SKYWL-471
    // ------------------------------
    100: '#fcdfcf',
    200: '#f38141',
    400: '#c04500',
    // ------------------------------

    50: '#fdeee6',
    300: '#f05700',
    500: '#772b00',
};

export default orange;
